import { useEffect, useState } from "react";
import FilterChip from "../../components/customComponents/FilterChip";
import { Button, CircularProgress } from "@mui/material";
// import { _delete_customer_api, _list_customer_api } from "../../DAL/User/User";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import CustomConfirmation from "../../components/customComponents/confirmation/CustomConfirmation";
import CustomMUITable from "../../components/customComponents/table/CustomMuiTable";
import CustomDrawer from "../../components/customComponents/drawer/CustomDrawer";
import ApplicationFilter from "./AdvisorFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";

import Tooltip from "@mui/material/Tooltip";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import {
  delete_attorney_Api,
  get_advisor_list_with_filters,
} from "../../DAL/adminAuth/auth";
import { show_proper_words } from "../../utils/constant";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const Advisors = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [openDelete, setOpenDelete] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const EMPTY_FILTER = {
    search: "",
    form_status: "",
    users: [],
    filter_by_dates: false,
    start_date: null,
    end_date: null,
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [tempFilters, setTempFilters] = useState({
    caseType: null,
    state: null,
    searchText: "",
  });

  const [userList, setUserList] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");

  const [deleteId, setDeleteId] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [sortDirection, setSortDirection] = useState("");

  const [states, setStates] = useState(""); // single state value
  const [caseType, setCaseType] = useState(null);
  const [successRate, setSuccessRate] = useState("createdAt");
  const [sortedBy, setSortedBy] = useState("down");

  let array = [1, 2, 3, 4, 5, 6, 7];
  let stars = "*";
  const get_user_list = async (
    case_type,
    stateSend,
    successRatio,
    sortedByparamId
  ) => {
    setIsLoading(true);

    const caseParam = case_type !== undefined ? case_type : caseType || "";

    const TypeParam = stateSend !== undefined ? stateSend : states || "";
    const ratioParam =
      successRatio !== undefined ? successRatio : successRate || "";
    const sortedByParam =
      sortedByparamId !== undefined ? sortedByparamId : sortedBy || "";

    const result = await get_advisor_list_with_filters(
      caseParam,
      TypeParam,
      ratioParam,
      sortedByParam,
      searchText,
      page,
      rowsPerPage
    );

    if (result.code === 200) {
      let data = result.advisor.map((item) => {
        let created_At = "N/A";
        let expertise = "N/A";
        let state = "N/A";
        let advisor = "N/A";
        let caseCapacity = 0 + "%";
        let caseDetails = "N/A";
        let caseCount = 0;
        let email = "N/A";
        let status = "N/A";
        let assigned_cases_count = 0;
        let pending_case_count = 0;
        let closed_cases_count = 0;
        let failed_cases_count = 0;
        let success_rate_completed = 0 + "%";
        console.log(item, "itemitemitemitemitem");
        if (item?.failed_cases_count) {
          failed_cases_count = item.failed_cases_count;
        }

        if (item?.closed_cases_count) {
          closed_cases_count = item.closed_cases_count;
        }
        if (item?.assigned_cases_count) {
          assigned_cases_count = item.assigned_cases_count;
        }
        if (item?.pending_case_count) {
          pending_case_count = item.pending_case_count;
        }

        if (item?.success_rate_completed) {
          success_rate_completed = item.success_rate_completed + "%";
        }

        if (item?.caseCount) {
          caseCount = item.caseCount;
        }

        if (item.createdAt) {
          created_At = moment(item.createdAt).format("DD-MM-YYYY");
        }
        if (item.name) {
          advisor = item.name;
        }
        if (item.caseCapacity) {
          caseCapacity = item.caseCapacity + "%";
        }

        if (item.status) {
          status = item?.status;
        }

        if (item.email) {
          email = item?.email;
        }
        if (item.state && item.state.length > 0) {
          state = item?.state;
        }
        if (item.expertise && item.expertise.length > 0) {
          expertise = item.expertise;
        }

        return {
          ...item,
          created_At,
          case_type,
          email,
          status,
          state,
          caseDetails,
          advisor,
          caseCapacity,
          expertise,
          caseCount,
          success_rate_completed,
          assigned_cases_count,
          closed_cases_count,
          failed_cases_count,
          pending_case_count,
        };
      });
      setUserList(data);
      setTotalCount(result.total_count);
      setTotalPages(result.total_pages);
      setIsLoading(false);
    } else {
      // enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const [userId, setUserId] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };
  const handleChangeOther = (name, value) => {
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickOpen = () => {
    navigate(`/users-list/add-user`);
  };

  const handleClickEdit = (row) => {
    console.log(row, "rowrow");
    navigate(`/list-advisors/update-advisor/${row._id}`);
  };
  const handleCaseDetail = (row) => {
    console.log(row, "rowrow");
    navigate(`/list-advisors/case-detail/${row._id}`, { state: { data: row } });
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const searchFunction = (e) => {
    e.preventDefault();
    setPage(0);
    setPageCount(1);
    get_user_list();
  };

  const handleClickPassWord = (row) => {
    setopenPasswordModal(true);
    setUserId(row.user_info._id);
  };
  const handleDeleteMember = async (memberId) => {
    console.log(memberId, "memberIdmemberIdmemberId");
    setDeleteLoading(true);
    const response = await delete_attorney_Api(memberId);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setDeleteDialogOpen(false);
      get_user_list();
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setDeleteDialogOpen(false);
    }
    setDeleteLoading(false);
  };

  const handleDelete = (row) => {
    console.log(row, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };
  const applyFilters = () => {
    setTempFilters({
      caseType: caseType,
      state: states,
    });
    setPage(0);
    setPageCount(1);
    handleCloseFilterDrawer();
    get_user_list();
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "mdi:pencil-outline",
      handleClick: handleClickEdit,
    },

    {
      label: "Delete ",
      icon: "mdi:delete-outline",
      handleClick: handleDelete,
    },
    {
      label: "Case Details",
      icon: "bxs:detail",
      handleClick: handleCaseDetail,
    },
  ];
  const handleAddAdvisor = () => {
    navigate("/list-advisors/add-advisor");
  };
  const clearFilters = () => {
    setCaseType("");
    setSearchText("");
    setTempFilters((prev) => ({ ...prev, state: null }));
    setTempFilters((prev) => ({ ...prev, caseType: null }));
    setPage(0);
    setPageCount(1);
    get_user_list("", "");
    handleCloseFilterDrawer();
  };
  const handleUp = () => {
    const caseParam = caseType ? caseType : "";
    const stateParam = states || "";
    setSortDirection("up");

    setSortedBy("up");
    setSuccessRate("successrate");

    get_user_list(caseParam, stateParam, "successrate", "up");
  };

  const handledown = (e) => {
    const caseParam = caseType ? caseType : "";
    const stateParam = states || "";
    setSortDirection("down");

    setSortedBy("down");
    setSuccessRate("successrate");

    get_user_list(caseParam, stateParam, "successrate", "down");
  };
  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    {
      id: "success_rate_completed",
      label: (
        <span style={{ color: "black" }}>
          Success Rate
          <Tooltip title="Sort: Lower to Higher">
            <ArrowUpwardIcon
              onClick={handleUp}
              sx={{
                color: sortDirection === "up" ? "black" : "gray",
                fontSize: 20,
                cursor: "pointer",
              }}
            />
          </Tooltip>
          <Tooltip title="Sort: Higher to Lower">
            <ArrowDownwardIcon
              onClick={handledown}
              sx={{
                color: sortDirection === "down" ? "black" : "gray",
                fontSize: 20,
                cursor: "pointer",
              }}
            />
          </Tooltip>
        </span>
      ),
      renderData: (row) => {
        console.log(row, "rowrowrowrowrowrowrowrow");
        return (
          <span
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {row?.success_rate_completed}
          </span>
        );
      },
    },
    {
      id: "state",
      label: "State",
      renderData: (row) => {
        const states = Array.isArray(row?.state) ? row.state : [];
        const formattedStates = [];

        for (let i = 0; i < states.length; i += 2) {
          formattedStates.push(states.slice(i, i + 2).join(", "));
        }

        return (
          <span>
            {formattedStates.map((line, index) => (
              <span key={index}>
                {line}
                {index !== formattedStates.length - 1 && <br />}
              </span>
            ))}
          </span>
        );
      },
    },
    // { id: "caseCount", label: "Case Count" },

    {
      id: "expertise",
      label: "Case Type",
      renderData: (row) => {
        const formatExpertise = (arr) => {
          if (!Array.isArray(arr)) return "";

          return arr
            .map((item) =>
              String(item)
                .split("_")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ")
            )
            .join(", "); // Join all formatted items with comma
        };

        return <span>{formatExpertise(row?.expertise)}</span>;
      },
    },
    { id: "caseCapacity", label: "Case Capacity" },
    { id: "assigned_cases_count", label: "Total Assigned Cases" },
    { id: "pending_case_count", label: "Total Pending Cases" },
    { id: "closed_cases_count", label: "Total Recovered  Cases" },
    { id: "failed_cases_count", label: "Total Failed Cases" },

    { id: "status", label: "Status", type: "row_status" },
  ];

  useEffect(() => {
    get_user_list();
  }, [page, rowsPerPage]);
  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this Attorney?"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />

      <div className="d-flex justify-content-between flex-wrap align-items-center mb-4 members_heading">
        <div>
          <h3>Attorneys</h3>
        </div>
        <div className="text-end">
          <Button
            variant="contained"
            className="me-2"
            onClick={handleAddAdvisor}
          >
            Add Attorney
          </Button>
          <Button
            variant="contained"
            startIcon={<FilterListIcon />}
            onClick={handleOpenFilterDrawer}
          >
            Filters
          </Button>
        </div>
      </div>

      {(tempFilters.caseType || tempFilters.state) && (
        <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
          {tempFilters.caseType && (
            <FilterChip
              label={<>Case Type: {show_proper_words(tempFilters.caseType)}</>}
              onClose={() => {
                setCaseType(null);
                setTempFilters((prev) => ({ ...prev, caseType: null }));
                get_user_list("", tempFilters.state ? tempFilters.state : "");
              }}
            />
          )}
          {tempFilters.state && (
            <FilterChip
              label={<>State: {show_proper_words(tempFilters.state)}</>}
              onClose={() => {
                setStates(null);
                setTempFilters((prev) => ({ ...prev, state: null }));
                get_user_list(
                  tempFilters.caseType ? tempFilters.caseType : "",
                  ""
                );
              }}
            />
          )}
          <button
            className="btn btn-sm filter-chip-clear-all"
            onClick={() => {
              setCaseType(null);
              setStates(null);
              setCaseType(null);
              setTempFilters({
                caseType: null,
                occurrencePeriod: null,
                state: null,
              });
              get_user_list("", "");
            }}
          >
            Clear All{" "}
            <span
              style={{ fontSize: "5px !important" }}
              className="chip-close clear-all"
            >
              ✕
            </span>
          </button>
        </div>
      )}
      <div className="mt-4">
        <CustomMUITable
          data={userList}
          TABLE_HEAD={TABLE_HEAD}
          MENU_OPTIONS={MENU_OPTIONS}
          pagePagination={true}
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          custom_search={{
            searchText: searchText,
            setSearchText: setSearchText,
            handleSubmit: searchFunction,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          handleChangePages={handleChangePages}
        />
      </div>
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <ApplicationFilter
            filterData={filterData}
            handleChange={handleChange}
            handleChangeOther={handleChangeOther}
            clearFilters={clearFilters}
            applyFilters={applyFilters}
            caseType={caseType}
            setCaseType={setCaseType}
            states={states}
            setStates={setStates}
          />
        }
      />
    </>
  );
};

export default Advisors;
